import {
  Component,
  OnInit,
  ViewEncapsulation,
  ViewChild,
  Output,
  EventEmitter,
  HostListener,
  ElementRef,
  Renderer2,
  AfterViewInit,
  OnDestroy,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
} from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { ToastrService } from 'ngx-toastr';
import $ from 'jquery';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatSort } from '@angular/material/sort';
import { SortingDialogComponent } from 'src/app/main/sorting-dialog/sorting-dialog.component';
import { ResizeEvent } from 'angular-resizable-element';
import { Subject, Subscription, takeUntil } from 'rxjs';
import { GlobalFunctionsService } from '@_services/global-functions.service';
import { TableColumnsService } from '@_services/table-columns.service';
import { MainAPiServiceService } from '@_services/main-api-service.service';
import { BehaviorService } from '@_services/Behavior.service';
import { SortingBehaviourService } from '@_services/sorting-behaviour.service';
import { TooltipService } from '@_services/tooltip.service';
import { FuseConfirmDialogComponent } from '@/app/Shared/confirm-dialog/confirm-dialog.component';
import { DIALOG_WIDTH } from '@/app/_constant/dialog-width.constants';

@Component({
  selector: 'app-activities',
  templateUrl: './activities.component.html',
  styleUrls: ['./activities.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ActivitiesComponent implements OnInit, AfterViewInit, OnDestroy {
  class: boolean;
  @ViewChild(MatTable, { read: ElementRef }) private matTableRef: ElementRef;
  activitiesFilter: FormGroup;
  isLoadingResults: boolean = false;
  displayedColumns: string[];
  columnsObj: any = [];
  tempColobj: any;
  FilterVal: any = [];
  theme_type = localStorage.getItem('theme_type');
  selectedColore: string = 'var(--highlighted-bg-row)';
  highlightedRows: any;
  currentActivitieData: any;
  pageSize: any;
  Activitiesdata: any = [];
  lastFilter: any;
  isDisplay: boolean = false;

  sortingDefaultState: any = {};
  sortactive: any;
  sortDirection: any;

  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort: MatSort;

  @Output() addActivity: EventEmitter<any> = new EventEmitter<any>();
  @Output() addDuplicateActivity: EventEmitter<any> = new EventEmitter<any>();

  activityForm: FormGroup;
  errorWarningData: any = {};
  toolTipList: any;
  selectedDataIs: any;
  successMsg: string;
  confirmDialogRef: MatDialogRef<any>;
  oldIsTrackId: string;
  DeletePostData: any;
  refreshId: any;
  ApiMethod: any;
  modeTypeIs: any;
  addNewActivities: boolean = false;
  appPermissions: any = JSON.parse(localStorage.getItem('app_permissions'));
  isActivityData: string;
  resizableMousemove: () => void;
  resizableMouseup: () => void;
  private _unsubscribeAll$: Subject<void> = new Subject();
  sub: Subscription;
  sub1: Subscription;
  sub2: Subscription;
  sub3: Subscription;
  sub4: Subscription;
  sub5: Subscription;
  sub6: Subscription;
  sub7: Subscription;
  sub8: Subscription;
  sub9: Subscription;
  sub10: Subscription;
  CurrenctSymbol: string = '';
  toolTipPostion = 'above';

  constructor(
    private _formBuilder: FormBuilder,
    private dialog: MatDialog,
    private TableColumnsService: TableColumnsService,
    private _mainAPiServiceService: MainAPiServiceService,
    private toastr: ToastrService,
    public behaviorService: BehaviorService,
    private SortingbehaviorService: SortingBehaviourService,
    private renderer: Renderer2,
    public globalFunService: GlobalFunctionsService,
    public tooltipService: TooltipService,
    private cd: ChangeDetectorRef,
  ) {
    localStorage.setItem('istrackid', 'ActivityScreenComponent');
    this.sub = this.SortingbehaviorService.activitySorting$.subscribe({
      next: (result: any) => {
        if (result) {
          this.sortingDefaultState = result;
          localStorage.setItem('activity_screen_sorting', JSON.stringify(result));
        } else {
          this.sortingDefaultState = JSON.parse(localStorage.getItem('activity_screen_sorting'));
        }
        this.cd.markForCheck();
      },
    });
    this.sub1 = this.SortingbehaviorService.ActivityFilterData$.subscribe({
      next: (result: any) => {
        if (result) {
          this.FilterVal = result;
        }
        this.cd.markForCheck();
      },
    });
    this.sub2 = this.behaviorService.APIretryCall$.subscribe({
      next: (result: any) => {
        if (
          localStorage.getItem('istrackid') == 'ActivityScreenComponent' &&
          result['click'] &&
          result['data']['activity']
        ) {
          if (!localStorage.getItem('activitie_list_columns')) {
            this.getTableFilter();
          }
          this.refreshActivities();
        }
        this.cd.markForCheck();
      },
    });

    this.activityForm = this._formBuilder.group({
      ACTIVITYGUID: [''],
      ACTIVITYTYPE: [''],
      ACTIVITYID: ['', Validators.required],
      DESCRIPTION: ['', Validators.required],
      GSTTYPE: [''],
      RATEPERUNIT: ['', { updateOn: 'blur' }, Validators.required],
      UNITDESCRIPTIONPLURAL: [''],
      UNITDESCRIPTIONSINGLE: [''],
      HIGHLIGHTITEM: [false],
    });
  }

  get f() {
    return this.activityForm.controls;
  }

  /**
   * It runs once after the component's view has been fully initialized.
   */
  ngOnInit() {
    const storedSymbol = localStorage.getItem('set_active_CURRENCYSYMBOL');
    this.CurrenctSymbol =
      storedSymbol && storedSymbol !== 'undefined' ? JSON.parse(storedSymbol) : '$';
    this.sub3 = this.behaviorService.permissionCheckforHeight$.subscribe({
      next: (data: any) => {
        this.class = data;
        this.cd.markForCheck();
      },
    });
    if (this.sortingDefaultState) {
      this.sortactive = this.sortingDefaultState.active;
      this.sortDirection = this.sortingDefaultState.direction;
    } else {
      this.sortactive = '';
      this.sortDirection = '';
    }
    this.behaviorService.resizeTableForAllView();
    const behaviorService = this.behaviorService;
    $(window).resize(() => {
      behaviorService.resizeTableForAllView();
    });
    this.activitiesFilter = this._formBuilder.group({
      TYPE: [' '],
      HighlightItem: false,
    });
    this.getTableFilter();
    if (JSON.parse(localStorage.getItem('activity_filter'))) {
      this.activitiesFilter.controls['TYPE'].setValue(this.FilterVal.ACTIVITYTYPE);
      this.activitiesFilter.controls['HighlightItem'].setValue(this.FilterVal.HIGHLIGHTITEM);
      this.loadData(this.FilterVal);
    } else {
      this.SortingbehaviorService.setActivityFilterData({
        ACTIVITYTYPE: ' ',
      });
      this.activitiesFilter.controls['TYPE'].setValue('');
      this.activitiesFilter.controls['HighlightItem'].setValue('');
    }
    this.loadData(this.FilterVal);

    this.sub4 = this.behaviorService.activitiesData$.subscribe({
      next: (result: any) => {
        if (result == null) {
          this.isActivityData = 'empty';
        } else {
          this.isActivityData = 'Notempty';
        }
        this.cd.markForCheck();
      },
    });
  }

  ngOnDestroy(): void {
    this._unsubscribeAll$.next();
    this._unsubscribeAll$.complete();
    this.sub?.unsubscribe();
    this.sub1?.unsubscribe();
    this.sub2?.unsubscribe();
    this.sub3?.unsubscribe();
    this.sub4?.unsubscribe();
    this.sub5?.unsubscribe();
    this.sub6?.unsubscribe();
    this.sub7?.unsubscribe();
    this.sub8?.unsubscribe();
    this.sub9?.unsubscribe();
    this.sub10?.unsubscribe();
  }

  /**
   * It runs only once after the component's view has been rendered.
   */
  ngAfterViewInit(): void {
    this.TableColumnsService.setTableResize(this.matTableRef.nativeElement.clientWidth);
  }

  /**
   * This function is used to loadActivities data
   * @param popupData -popup data value
   */
  loadActivities(popupData?: any) {
    this.isLoadingResults = true;
    let payload: any = {
      Action: 'GetData',
      Filters: {},
    };
    if (popupData) {
      payload.Filters.ACTIVITYGUID = popupData.ACTIVITYGUID;
      this.activityForm.controls['ACTIVITYGUID'].setValue(payload.ACTIVITYGUID);
    } else {
      payload.Filters.ACTIVITYGUID = this.selectedDataIs.ACTIVITYGUID;
      this.activityForm.controls['ACTIVITYGUID'].setValue(this.selectedDataIs.ACTIVITYGUID);
    }
    this.sub5 = this._mainAPiServiceService.getSetData(payload, 'activity').subscribe({
      next: (response: any) => {
        if (response.CODE === 200 && (response.STATUS === 'OK' || response.STATUS === 'success')) {
          if (response.DATA.RECORDS[0]) {
            let activityData = response.DATA.RECORDS[0];
            // this.toolTipList = response.DATA.FIELDTIPS;
            this.activityForm.controls['ACTIVITYTYPE'].setValue(activityData.ACTIVITYTYPEDESC);
            this.activityForm.controls['ACTIVITYID'].setValue(activityData.ACTIVITYID);
            this.activityForm.controls['DESCRIPTION'].setValue(activityData.DESCRIPTION);
            this.activityForm.controls['GSTTYPE'].setValue(activityData.GSTTYPEDESC);
            this.activityForm.controls['RATEPERUNIT'].setValue(
              parseFloat(activityData.RATEPERUNIT).toFixed(2),
            );
            this.activityForm.controls['UNITDESCRIPTIONPLURAL'].setValue(
              activityData.UNITDESCRIPTIONPLURAL,
            );
            this.activityForm.controls['UNITDESCRIPTIONSINGLE'].setValue(
              activityData.UNITDESCRIPTIONSINGLE,
            );
            this.activityForm.controls['HIGHLIGHTITEM'].setValue(activityData.HIGHLIGHTITEM);
          } else {
            this.toastr.error('No data found please try again');
          }
        }
        this.isLoadingResults = false;
        this.cd.markForCheck();
      },
      error: (error: any) => {
        this.toastr.error(error);
        this.isLoadingResults = false;
        this.cd.markForCheck();
      },
    });
  }

  /**
   * This function is used to set the default validation data.
   */
  defultValidation(): void {
    let tempError: any = [];
    let tempWarning: any = [];
    tempWarning['RATEPERUNIT'] = {};
    tempWarning['UNITDESCRIPTIONSINGLE'] = {};
    tempWarning['UNITDESCRIPTIONPLURAL'] = {};

    tempError['ACTIVITYID'] = {};
    tempError['DESCRIPTION'] = {};
    this.errorWarningData = { Error: tempError, Warning: tempWarning };
    this.cd.markForCheck();
  }

  /**
   * this function is used to sort the data
   * @param val
   */
  sortData(val: any) {
    this.SortingbehaviorService.activitySorting(val);
    this.setDefaultWidth(this.displayedColumns, 0);
  }

  /**
   * This function is used to get the table filter data
   */
  getTableFilter() {
    let activitesListColumns: any = JSON.parse(localStorage.getItem('activitie_list_columns'));
    if (activitesListColumns && activitesListColumns != null) {
      let data = this.TableColumnsService.filtertableColum((activitesListColumns.columnsObj ?? activitesListColumns['ColumnsObj']));
      this.displayedColumns = activitesListColumns.displayedColumns;
      this.tempColobj = data.tempColobj;

      // EXPEND Flage for new design table.
      this.tempColobj.forEach((element: any) => {
        element.EXPEND = false;
      });

      this.columnsObj = (activitesListColumns.columnsObj ?? activitesListColumns['ColumnsObj']);
      this.cd.markForCheck();
    } else {
      this.sub6 = this.TableColumnsService.getTableFilter('Activities', '').subscribe({
        next: (response: any) => {
          if (response.CODE == 200 && response.STATUS == 'success') {
            let data = this.TableColumnsService.filtertableColum(response.DATA.RECORDS);
            this.displayedColumns = data.showcol;
            this.displayedColumns.unshift('Expand');
            this.tempColobj = data.tempColobj;
            this.tempColobj.forEach((element: any) => {
              element.EXPEND = false;
            });
            this.columnsObj = data.colobj;
            localStorage.setItem(
              'activitie_list_columns',
              JSON.stringify({
                columnsObj: data.colobj,
                displayedColumns: data.showcol,
              }),
            );
          }
          this.cd.markForCheck();
        },
        error: (error: any) => {
          this.toastr.error(error);
          this.cd.markForCheck();
        },
      });
    }
  }

  /**
   * This function is used to Resizing the data value
   * @param event -event data value
   * @param columnName -column name data value
   */
  onResizing(event: ResizeEvent, columnName: any): void {
    if (event.edges.right) {
      const cssValue = event.rectangle.width + 'px';
      const columnElts = document.getElementsByClassName('mat-column-' + columnName);
      for (let i = 0; i < columnElts.length; i++) {
        const currentEl = columnElts[i] as HTMLDivElement;
        currentEl.style.width = cssValue;
      }
      const indexData = this.columnsObj.findIndex((col: any) => col.COLUMNID === columnName);
      this.columnsObj[indexData]['WIDTH'] = event.rectangle.width;
      localStorage.setItem(
        'activitie_list_columns',
        JSON.stringify({
          columnsObj: this.columnsObj,
          displayedColumns: this.displayedColumns,
        }),
      );
      this.cd.markForCheck();
    }
  }

  /**
   * This function is used to on resize end data value
   * @param event -event data value
   * @param columnName -column name data value
   */
  onResizeEnd(event: ResizeEvent, columnName: any): void {
    this.TableColumnsService.SaveWidthData(this.columnsObj, 'Activities', '');
  }

  /**
   * This function is used to set default width data
   * @param displayedColumns -displayed column data
   * @param timeout -time out data
   * @returns -width
   */
  setDefaultWidth(displayedColumns: any, timeout: any) {
    if (!displayedColumns) {
      return;
    }

    setTimeout(() => {
      displayedColumns?.forEach((element: any) => {
        if (element == 'Expand') {
          return;
        }

        let temWidth = this.tempColobj[element]['WIDTH'];
        const cssValue = temWidth + 'px';
        const columnElts = document.getElementsByClassName('mat-column-' + element);
        for (let i = 0; i < columnElts.length; i++) {
          const currentEl = columnElts[i] as HTMLDivElement;
          currentEl.style.visibility = 'inherit';
          currentEl.style.width = cssValue;
        }
      });
      this.cd.markForCheck();
    }, timeout);
  }

  /**
   * This function is used to change the pagination data
   * @param event -event data
   */
  onPaginateChange(event: any) {
    this.setDefaultWidth(this.displayedColumns, 0);
    this.pageSize.activities = event.pageSize;
    localStorage.setItem('lastPageSize', JSON.stringify(this.pageSize));
    this.cd.markForCheck();
  }

  /**
   * This function is used to refresh the activities
   */
  refreshActivities() {
    this.loadData(this.FilterVal);
  }

  /**
   * This function is used to load the data value
   * @param filterData -filter data value
   */
  loadData(filterData: any) {
    let Activitydata: any = {
      Action: 'GetData',
      Filters: {
        ACTIVITYTYPE: filterData.ACTIVITYTYPE,
        HIGHLIGHTITEM: filterData.HIGHLIGHTITEM,
      },
    };
    this.isLoadingResults = true;
    this.sub7 = this._mainAPiServiceService.getSetData(Activitydata, 'activity').subscribe({
      next: (response: any) => {
        if (response.CODE === 200 && (response.STATUS === 'OK' || response.STATUS === 'success')) {
          this.behaviorService.activitiesData(null);
          if (response.DATA.RECORDS[0]) {
            this.isDisplay = false;
            this.behaviorService.activitiesData(response.DATA.RECORDS[0]);
            this.highlightedRows = response.DATA.RECORDS[0].ACTIVITYGUID;
            this.Activitiesdata = response.DATA.RECORDS[0];
            localStorage.setItem('current_ActivityData', JSON.stringify(response.DATA.RECORDS[0]));
          } else {
            this.isDisplay = true;
          }
          this.Activitiesdata = new MatTableDataSource(response.DATA.RECORDS);
          this.Activitiesdata.paginator = this.paginator;
          this.Activitiesdata.sort = this.sort;
          this.setDefaultWidth(this.displayedColumns, 500);
        } else {
          this.Activitiesdata = new MatTableDataSource([]);
          this.Activitiesdata.paginator = this.paginator;
          this.Activitiesdata.sort = this.sort;
          this.setDefaultWidth(this.displayedColumns, 500);
        }
        this.isLoadingResults = false;
        this.behaviorService.loadingSystemSetting('activities');
        this.cd.markForCheck();
      },
      error: (error: any) => {
        this.toastr.error(error);
        this.isLoadingResults = false;
        this.cd.markForCheck();
      },
    });
    this.pageSize = JSON.parse(localStorage.getItem('lastPageSize'));
  }

  /**
   * This function is used to openDialog data
   */
  openDialog() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = '800px';
    dialogConfig.disableClose = true;
    dialogConfig.data = {
      data: this.columnsObj,
      type: 'Activities',
      list: '',
    };
    dialogConfig.panelClass = 'dialog-panel-class';
    dialogConfig.backdropClass = 'cdk-overlay-dark-backdrop';
    const dialogRef = this.dialog.open(SortingDialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe({
      next: (result: any) => {
        if (result) {
          this.displayedColumns = result.columObj;
          this.columnsObj = result.columnameObj;
          this.tempColobj = result.tempColobj;
          localStorage.setItem(
            'activitie_list_columns',
            JSON.stringify({
              displayedColumns: result.columObj,
              columnsObj: result.columnameObj,
            }),
          );
          if (!result.columObj) {
            this.Activitiesdata = new MatTableDataSource([]);
            this.Activitiesdata.paginator = this.paginator;
            this.Activitiesdata.sort = this.sort;
            this.isDisplay = true;
          } else {
            this.loadData({ ACTIVITYTYPE: '' });
          }
        }
        this.cd.markForCheck();
      },
    });
  }

  /**
   * This function is used to Change the type data
   * @param EventVal -event value data
   */
  TypeChange(EventVal: any) {
    this.FilterVal.ACTIVITYTYPE = EventVal.value;
    this.SortingbehaviorService.setActivityFilterData(this.FilterVal);
    this.loadData(this.FilterVal);
  }

  /**
   * This function is used to set active data
   * @param rowData -row data value
   */
  setActiveData(rowData: any) {
    this.behaviorService.activitiesData(rowData);
    localStorage.setItem('current_ActivityData', JSON.stringify(rowData));
    this.cd.markForCheck();
  }

  /**
   * This function is used to Highlight changes
   * @param event -data
   */
  HighlightChange(event: any) {
    this.FilterVal.HIGHLIGHTITEM = event.checked;
    this.SortingbehaviorService.setActivityFilterData(this.FilterVal);
    this.loadData(this.FilterVal);
  }

  /**
   * This function is used to edit Expand data
   * @param SelectedRow
   * @param Index
   */
  editModeExpand(SelectedRow: any, Index: any) {
    const isSameRow = SelectedRow.ACTIVITYGUID === this.selectedDataIs?.ACTIVITYGUID;
    const willExpand = isSameRow ? !SelectedRow.EXPEND : true;

    this.closeAddPanel();
    this.selectedDataIs = SelectedRow;
    this.modeTypeIs = willExpand ? 'edit' : '';

    if (willExpand) {
      this.loadActivities();
      this.defultValidation();
    }

    this.setExpandedRow(SelectedRow.ACTIVITYGUID, willExpand);
  }

  /**
   * This function is used to Save Activity data
   */
  saveActivity() {
    this.isLoadingResults = true;
    let PostData: any = {
      ACTIVITYID: this.f.ACTIVITYID.value,
      ACTIVITYTYPE: this.f.ACTIVITYTYPE.value,
      DESCRIPTION: this.f.DESCRIPTION.value,
      GSTTYPE: this.f.GSTTYPE.value,
      RATEPERUNIT: this.f.RATEPERUNIT.value,
      UNITDESCRIPTIONSINGLE: this.f.UNITDESCRIPTIONSINGLE.value,
      UNITDESCRIPTIONPLURAL: this.f.UNITDESCRIPTIONPLURAL.value,
      HIGHLIGHTITEM: this.f.HIGHLIGHTITEM.value == true ? 1 : 0,
    };

    //let FormAction = 'update';

    let FormAction = this.modeTypeIs == 'edit' ? 'update' : 'insert';
    if (this.modeTypeIs == 'edit') {
      PostData.ACTIVITYGUID = this.f.ACTIVITYGUID.value;
      this.successMsg = `${PostData.ACTIVITYTYPE} updated successfully`;
    } else {
      this.successMsg = `${PostData.ACTIVITYTYPE} saved successfully`;
    }

    let PostActivityData: any = {
      FormAction: FormAction,
      VALIDATEONLY: true,
      Data: PostData,
    };
    this.sub8 = this._mainAPiServiceService.getSetData(PostActivityData, 'activity').subscribe({
      next: (res: any) => {
        if (res.CODE == 200 && res.STATUS == 'success') {
          this.checkValidation(res.DATA.VALIDATIONS, PostActivityData);
        } else if (res.CODE == 451 && res.STATUS == 'warning') {
          this.checkValidation(res.DATA.VALIDATIONS, PostActivityData);
        } else if (res.CODE == 450 && res.STATUS == 'error') {
          this.checkValidation(res.DATA.VALIDATIONS, PostActivityData);
        } else {
          this.isLoadingResults = false;
          this.toastr.error(res.MESSAGE);
        }
        this.cd.markForCheck();
      },
      error: (err: any) => {
        this.isLoadingResults = false;
        this.toastr.error(err);
        this.cd.markForCheck();
      },
    });
  }

  /**
   * This function is used to check validation data
   * @param bodyData -body data
   * @param PostActivityData -post Activity data
   * @param ApiName -Api Name
   */
  async checkValidation(bodyData: any, PostActivityData: any, ApiName?: any) {
    this.isLoadingResults = false;
    await this.globalFunService.checkValidation(bodyData, PostActivityData).subscribe({
      next: (data: any) => {
        if (data) {
          this.errorWarningData = data.errorWarningData;
          //this.errorWarningDataArray = data.errorWarningData;
          if (data.callback) {
            this.saveActivityData(PostActivityData);
          }
        }
        this.cd.markForCheck();
      },
    });
  }

  /**
   * This function is used to Save Activity data
   * @param PostActivityData -Activity data value
   */
  saveActivityData(PostActivityData: any) {
    this.isLoadingResults = false;
    PostActivityData.VALIDATEONLY = false;
    this.sub9 = this._mainAPiServiceService.getSetData(PostActivityData, 'activity').subscribe({
      next: (res: any) => {
        if (res.CODE == 200 && res.STATUS == 'success') {
          this.toastr.success(this.successMsg);
          // if(this.modeTypeIs == 'Duplicate' || this.modeTypeIs == 'insert'){
          $('#refreshActivities').click();
          // };
          this.closeAddPanel();
          this.closeExpandedActivityRows();
        } else if (res.CODE == 451 && res.STATUS == 'warning') {
          this.toastr.warning(this.successMsg);
          this.isLoadingResults = false;
        } else if (res.CODE == 450 && res.STATUS == 'error') {
          this.toastr.error(res.STATUS);
          this.isLoadingResults = false;
        }
        this.cd.markForCheck();
      },
      error: (err: any) => {
        this.isLoadingResults = false;
        this.toastr.error(err);
        this.cd.markForCheck();
      },
    });
  }

  /**
   * Delete Activity Dialog data.
   */
  DeleteActivityDialog(): void {
    this.confirmDialogRef = this.dialog.open(FuseConfirmDialogComponent, {
      disableClose: true,
      panelClass: 'dialog-panel-class',
      backdropClass: 'cdk-overlay-dark-backdrop',
      width: DIALOG_WIDTH.FULL,
    });

    this.confirmDialogRef.componentInstance.confirmMessage = 'Are you sure you want to delete?';
    this.confirmDialogRef.afterClosed().subscribe({
      next: (result: any) => {
        if (result) {
          let ActivityData = JSON.parse(localStorage.getItem('current_ActivityData'));
          let postData = {
            FormAction: 'delete',
            data: { ACTIVITYGUID: ActivityData.ACTIVITYGUID },
          };
          let RefreshIdArray: any = ['#refreshActivities'];
          this.SetVariableForRetry(postData, 'activity', RefreshIdArray);
          this._mainAPiServiceService.getSetData(postData, 'activity').subscribe({
            next: (res: any) => {
              if (res.STATUS == 'success' && res.CODE == 200) {
                localStorage.setItem('istrackid', this.oldIsTrackId);
                $('#refreshActivities').click();
                this.toastr.success('Deleted successfully');
              } else if (res.CODE == 451 && res.STATUS == 'warning') {
                this.checkValidation(res.DATA.VALIDATIONS, postData, 'activity');
              } else if (res.CODE == 450 && res.STATUS == 'error') {
                this.checkValidation(res.DATA.VALIDATIONS, postData, 'activity');
              } else if (res.MESSAGE == 'Not logged in') {
                this.confirmDialogRef.close(false);
              }
              this.cd.markForCheck();
            },
          });
        }
        this.confirmDialogRef = null;
        this.cd.markForCheck();
      },
    });
  }

  /**
   * This function is used to set the default varialbe data
   * @param PostData -post data value
   * @param Methode -method data value
   * @param RefreshArray -refreshArray data
   */
  SetVariableForRetry(PostData: any, Methode: any, RefreshArray: any) {
    this.oldIsTrackId = localStorage.getItem('istrackid');
    this.DeletePostData = PostData;
    this.ApiMethod = Methode;
    this.refreshId = RefreshArray;
    localStorage.setItem('istrackid', 'DeleteDataClick');
  }

  /**
   * This function is used to set old strack id
   * @param type
   */
  SetOldistrackid(type: any) {
    if (type === 'open') {
      this.oldIsTrackId = localStorage.getItem('istrackid');
    } else {
      localStorage.setItem('istrackid', this.oldIsTrackId);
    }
  }

  /**
   * This function is used to addActivities data
   * @param actionType
   */
  async addActivities(actionType?: any) {
    if (this.appPermissions?.[30]?.Create == 0) {
      return;
    }

    this.closeExpandedActivityRows();
    this.modeTypeIs = 'insert';
    await this.resetFields();
    await this.SetOldistrackid('open');
    this.addNewActivities = true;
    await this.NewActivity();
    await this.defultValidation();
    this.cd.markForCheck();
  }

  /**
   * Cancle data
   */
  cancle() {
    this.addNewActivities = false;
    this.modeTypeIs = '';
    this.cd.detectChanges();
  }

  cancelDuplicate() {
    this.closeExpandedActivityRows();
    this.modeTypeIs = '';
    this.cd.markForCheck();
  }

  closeAddPanel() {
    this.addNewActivities = false;
    this.modeTypeIs = this.modeTypeIs === 'insert' ? '' : this.modeTypeIs;
  }

  closeExpandedActivityRows() {
    if (!this.Activitiesdata?.data?.length) {
      return;
    }

    this.Activitiesdata.data.forEach((row: any) => {
      row.EXPEND = false;
    });
    this.refreshActivitiesTableData();
  }

  setExpandedRow(activityGuid: string, expanded: boolean) {
    if (!this.Activitiesdata?.data?.length) {
      return;
    }

    this.Activitiesdata.data.forEach((row: any) => {
      row.EXPEND = row.ACTIVITYGUID === activityGuid ? expanded : false;
    });
    this.refreshActivitiesTableData();
  }

  refreshActivitiesTableData() {
    if (!this.Activitiesdata?.data) {
      return;
    }

    this.Activitiesdata = new MatTableDataSource([...this.Activitiesdata.data]);
    this.Activitiesdata.paginator = this.paginator;
    this.Activitiesdata.sort = this.sort;
    this.cd.markForCheck();
  }

  /**
   * This function is used to addduplicate Activityes
   * @param actionType -action type
   * @returns activity data
   */
  addDuplicateActivities(actionType: any) {
    if (this.appPermissions?.[30]?.Create == 0 || this.isActivityData == 'empty') {
      return false;
    }

    const ActivityData = JSON.parse(localStorage.getItem('current_ActivityData'));
    if (!ActivityData) {
      this.toastr.error('Please Select Activity');
      return false;
    }

    this.closeAddPanel();
    this.SetOldistrackid('open');
    this.modeTypeIs = 'Duplicate';
    this.loadActivities({
      action: actionType,
      ACTIVITYGUID: ActivityData.ACTIVITYGUID,
    });
    this.defultValidation();
    this.setExpandedRow(ActivityData.ACTIVITYGUID, true);
    return true;
  }

  /**
   * This function is used to set the New Activity data
   */
  NewActivity() {
    // this.sub10 = this._mainAPiServiceService
    //     .getSetData({ ACTION: "default", DATA: {} }, "activity")
    //     .subscribe((response) => {
    //         if (
    //             response.CODE == 200 &&
    //             (response.STATUS == "OK" || response.STATUS == "success")
    //         ) {
    //             console.log(response.DATA);
    //             this.toolTipList = response.DATA.FIELDTIPS;
    //         }
    //     });
    let TooltipData = JSON.parse(localStorage.getItem('FieldTooltipData'));
    if (TooltipData && TooltipData['Activity']) {
      this.toolTipList = TooltipData['Activity'];
      this.cd.markForCheck();
    } else {
      this.tooltipService
        .saveToolTipData('Activity')
        .pipe(takeUntil(this._unsubscribeAll$))
        .subscribe({
          next: (data: any) => {
            this.toolTipList = data;
            this.cd.markForCheck();
          },
          error: (err: any) => {
            console.error('Tooltip fetch failed:', err);
            this.toastr.error(err);
            this.toolTipList = [];
            this.cd.markForCheck();
          },
        });
    }
  }

  /**
   * This function is used to reset the all fields
   */
  resetFields() {
    this.activityForm.controls['ACTIVITYGUID'].setValue('');
    this.activityForm.controls['ACTIVITYTYPE'].setValue('');
    this.activityForm.controls['ACTIVITYID'].setValue('');
    this.activityForm.controls['DESCRIPTION'].setValue('');
    this.activityForm.controls['GSTTYPE'].setValue('');
    this.activityForm.controls['RATEPERUNIT'].setValue('0.00');
    this.activityForm.controls['UNITDESCRIPTIONPLURAL'].setValue('');
    this.activityForm.controls['UNITDESCRIPTIONSINGLE'].setValue('');
    this.activityForm.controls['HIGHLIGHTITEM'].setValue('');
    this.cd.markForCheck();
  }

  //   onResizeColumnSetting(event , index){
  //     //event : selected column.
  //     //index : selected column index.
  //     //renderer : dont make this comman it's give issue import in your component.
  //     //displayedColumns : displayedColumns name's (Table Header names).
  //     //matTableRef : most importent please import in component wise don't make it comman.
  //     // last field is localstorage name which use to store columnObj

  //     this.TableColumnsService.onResizeColumn(event , index , this.renderer , this.displayedColumns , this.matTableRef , this.columnsObj , 'activitie_list_columns');
  //   };

  //For resize this fuction is most impotent don't make it comman it's give issue in future.
  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.TableColumnsService.setTableResize(this.matTableRef.nativeElement.clientWidth);
  }

  /**
   * This function is used to close all expanded rows data
   */
  CloseAllExpandedrows() {
    this.cancelDuplicate();
  }
}
